import React from 'react';

import FullWrapper from '../full-wrapper';

import './style.sass';
import parse from 'html-react-parser';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonTitle from '../../../common-components/common-title';
type ReviewAuthorType = {
    img: string;
    title: string;
    subtitle: string;
};

type ReviewType = {
    reviewTitle?: string;
    reviewText: string;
    reviewAuthors: ReviewAuthorType[];
    isBlank: boolean;
    link: string;
};

type ReviewPropsType = {
    Review: ReviewType;
    className?: string;
};

const Review = ({
    Review: { reviewTitle = 'Отзыв', reviewText, reviewAuthors, isBlank, link },
    className,
}: ReviewPropsType) => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={50} animateOnce={true} duration={1}>
            <FullWrapper className="review">
                <div className="review__container">
                    <CommonTitle className={className}>{reviewTitle}</CommonTitle>
                    <ScrollAnimation
                        animateIn="fadeInUp"
                        offset={0}
                        animateOnce={true}
                        duration={1}
                    >
                        <div className="review__text">
                            <span dangerouslySetInnerHTML={{ __html: reviewText }} />
                            <span className="review__quote review__quote--not-absolute">
                                &raquo;
                            </span>
                            <span className="review__quote review__quote--absolute">&raquo;</span>
                        </div>
                    </ScrollAnimation>
                    <ScrollAnimation
                        animateIn="fadeInUp"
                        offset={0}
                        delay={500}
                        animateOnce={true}
                        duration={1}
                    >
                        <div className="review__author-wrap">
                            {isBlank
                                ? reviewAuthors.map((author, index) => (
                                      <a
                                          key={index}
                                          href={link}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          className="review__author-container review__author-container--link"
                                      >
                                          {author.img && (
                                              <div
                                                  className="review__author-img"
                                                  style={{
                                                      backgroundImage: `url(${author.img})`,
                                                  }}
                                              />
                                          )}
                                          <div className="review__author-text-container">
                                              <div className="review__author-title">
                                                  {author.title}
                                              </div>
                                              <div className="review__author-subtitle">
                                                  {author.subtitle}
                                              </div>
                                          </div>
                                      </a>
                                  ))
                                : reviewAuthors.map((author, index) => (
                                      <div className="review__author-container" key={index}>
                                          {author.img && (
                                              <div
                                                  className="review__author-img"
                                                  style={{
                                                      backgroundImage: `url(${author.img})`,
                                                  }}
                                              />
                                          )}
                                          <div className="review__author-text-container">
                                              <div className="review__author-title">
                                                  {author.title}
                                              </div>
                                              <div className="review__author-subtitle">
                                                  {author.subtitle}
                                              </div>
                                          </div>
                                      </div>
                                  ))}
                        </div>
                    </ScrollAnimation>
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Review;
